/**
 * @var service.ready
 * @var service.banners
 * @param grecaptcha
 * @param variables {{ recaptcha: object, profiles: object }}
 */
const PostsController =  ['$scope', '$http', '$modules', function($scope, $http, $modules) {

    $scope.actions = {
        like: function () {
            $http.get( $scope.service.post.links.like, {withCredentials: true}).then(function(response) {
                $scope.service.post.likes = response.data.likes;
            })
            let likeButton = document.getElementById('blog-like-button')
            if (likeButton.dataset.liked === 'true') {
                likeButton.dataset.liked = 'false';
            } else {
                likeButton.dataset.liked = 'true';
            }
        },
        scrollToComment: function () {
            let element = document.getElementById('comments');
            let value = element.offsetTop;
            while ( element = element.offsetParent ) {
                value += element.offsetTop;
            }
            window.scrollTo({ top: value, behavior: 'smooth' });
        },
    };

    $scope.data = {
        commentCount: function () {
            if(typeof $scope.service.comments === 'undefined') {
                return '';
            }

            return Object.values($scope.service.comments.items).length;
        }
    };

}];

export default PostsController;
